<div class="grid-wrapper">
  <div class="grid-toolbar">
    <div class="toolbar-spacer"></div>
    <button type="button" class="btn btn-primary bm-btn" data-bs-toggle="modal" data-bs-target="#bookmarkModal"
      aria-expanded="false" (click)="ontoggleBookmarkSidenav()">
      <i class="fa fa-bookmark" aria-hidden="true"></i>
    </button>
    <button class="btn btn-sm btn-primary export-btn" (click)="onExport()">Export</button>
  </div>

  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav mode="side" position="end" [(opened)]="isBookmarksPanelOpen" class="bookmarks-panel">
      <app-bookmarks (loadBookmarkInGrid)="loadBookmark()" [bookmarkGrid]="bookmarkGrid"></app-bookmarks>
    </mat-sidenav>
    <mat-sidenav-content class="grid-content">
      <div>
        <ag-grid-angular class="grid ag-theme-alpine" [columnDefs]="columnDefs" [gridOptions]="gridOptions"
          (stateUpdated)="onStateUpdated()" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
